/**
 * Normaliza resultPayload de jobs IA (objeto ou JSON string).
 */
export function normalizeJobResultPayload(payload) {
  if (payload == null) return null;
  if (typeof payload === 'string') {
    const t = payload.trim();
    if (!t) return null;
    try {
      return JSON.parse(t);
    } catch {
      return null;
    }
  }
  if (typeof payload === 'object') return payload;
  return null;
}

export function getOnboardingSuggestionsFromJobResult(resultOrJob) {
  if (resultOrJob == null) return [];

  if (Array.isArray(resultOrJob.suggestions)) {
    return resultOrJob.suggestions;
  }

  const fromPayload = normalizeJobResultPayload(resultOrJob.resultPayload);
  if (Array.isArray(fromPayload?.suggestions)) {
    return fromPayload.suggestions;
  }

  const parsed = normalizeJobResultPayload(resultOrJob);
  if (Array.isArray(parsed?.suggestions)) {
    return parsed.suggestions;
  }

  return [];
}
